import React, {
	Component,
} from "react";
import {
	Container,
	Jumbotron,
	Card,
} from "react-bootstrap";
import "../../App.css";
export class Pendant extends Component {
	render() {
		return (
			<div className="Home">
				<Container
					style={{
						display:
							"flex",
						justifyContent:
							"center",
						justifyContent:
							"space-around",
						marginBottom:
							"20%",
						flexWrap:
							"wrap",
					}}
					fluid>
					<script async
  src="https://js.stripe.com/v3/buy-button.js">
</script>

<stripe-buy-button
  buy-button-id="buy_btn_1SttULLtyWpTzVZraZqewHpw"
  publishable-key="pk_live_51OufQ5LtyWpTzVZr8n6kSbefb2lMScXVk89wC5g4ZTMTqHatpWRcFXj4TqVi5uryvghdyjosCLV4jaHnXsaqD1Em00tQr8ErtL"
>
</stripe-buy-button>


<script async
  src="https://js.stripe.com/v3/buy-button.js">
</script>

<stripe-buy-button
  buy-button-id="buy_btn_1SwVnRLtyWpTzVZrH63CsxHb"
  publishable-key="pk_live_51OufQ5LtyWpTzVZr8n6kSbefb2lMScXVk89wC5g4ZTMTqHatpWRcFXj4TqVi5uryvghdyjosCLV4jaHnXsaqD1Em00tQr8ErtL"
>
</stripe-buy-button>
				</Container>
			</div>
		);
	}
}

export default Pendant;
